import { supabase, TABLES } from "../lib/supabase";

export interface ContractCategory {
  id: number;
  category: string;
  active: boolean;
}

export interface CreateCategoryData {
  category: string;
  active: boolean;
}

export interface UpdateCategoryData {
  category?: string;
  active?: boolean;
}

export async function getContractCategories(): Promise<ContractCategory[]> {
  const { data, error } = await supabase
    .from(TABLES.CONTRACT_CATEGORIES)
    .select("*")
    .eq("active", true)
    .order("category");

  if (error) {
    console.error("Error fetching contract categories:", error);
    return [];
  }

  return data || [];
}

export async function createCategory(
  data: CreateCategoryData
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_CATEGORIES)
      .insert([data]);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error creating category:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export async function updateCategory(
  id: number,
  data: UpdateCategoryData
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_CATEGORIES)
      .update(data)
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error updating category:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}

export async function deleteCategory(
  id: number
): Promise<{ success: boolean; error?: string }> {
  try {
    const { error } = await supabase
      .from(TABLES.CONTRACT_CATEGORIES)
      .delete()
      .eq("id", id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error("Error deleting category:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
}
